import axios from "axios";
import React from "react";
import ReactDOM from "react-dom";
import Loader from "../Components/loader/Loader";

export const BASE_URL_Local = "http://127.0.0.1:8000/api/";
// export const BASE_URL_Local = "https://jcbk.teeblanka.com/api/";
export const BASE_URL_SERVER ="https://jcbk.teeblanka.com/api/";

export const genOtp = (digits = 4) => {
  const min = Math.pow(10, digits - 1);
  const max = Math.pow(10, digits) - 1;
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const getRandomNumberInRange = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const callAjax = async (url, data, loader = true) => {
  try {
    let BASE_URL =
      window.location.hostname === "localhost"
        ? BASE_URL_Local
        : BASE_URL_SERVER;
    const config = {
      method: "post",
      url: BASE_URL + url,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: data,
    };

    ReactDOM.render(<Loader bal={loader} />, document.getElementById("root1")); // Show Loader before API call
    const response = await axios(config);
    ReactDOM.render(<Loader bal={false} />, document.getElementById("root1")); // Hide Loader after API call
    let ret;
    // console.log(response);
    ret = { msg: "", code: 200, data: response.data.data };
    return ret;
  } catch (error) {
    console.log(error);
    ReactDOM.render(<Loader bal={false} />, document.getElementById("root1")); // Hide Loader on error
    return {
      msg: "something went wrong! please try again ",
      code: 500,
      data: [],
    };
  }
};

export const callAjax_File = async (url, data) => {
  try {
    let BASE_URL =
      window.location.hostname === "localhost"
        ? BASE_URL_Local
        : BASE_URL_SERVER;
    const config = {
      method: "post",
      url: BASE_URL + url,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: data,
    };

    ReactDOM.render(<Loader />, document.getElementById("root1")); // Show Loader before API call
    const response = await axios(config);

    ReactDOM.render(<Loader bal={false} />, document.getElementById("root1")); // Hide Loader after API call
    let ret;
    ret = { msg: "", code: 200, data: response.data.data };
    return ret;
  } catch (error) {
    ReactDOM.render(<Loader bal={false} />, document.getElementById("root1")); // Hide Loader on error
    return { msg: "something went wrong! please try again ", code: 500 };
  }
};

export const getUrl = (path) => {
  let BASE_URL =window.location.hostname === "localhost"? BASE_URL_Local: BASE_URL_SERVER;
  return BASE_URL;
};

export const getUrl_PDF = (path) => {
  let BASE_URL ="https://teeblanka.com/";
  return BASE_URL;
};

export const getPHP_Url = (path) => {
  let BASE_URL =window.location.hostname === "localhost"? 
  process.env.REACT_APP_WA_API_LOCAL: process.env.REACT_APP_WA_API;
  return BASE_URL;
};

export const getImageUrl = (path) => {
  // BASE_URL_Local
  let BASE_URL =
    window.location.hostname === "localhost" ? BASE_URL_Local : BASE_URL_SERVER;
    BASE_URL="https://jcbk.teeblanka.com/api/"
    // BASE_URL="https://jcbk.teeblanka.com/api/"
    BASE_URL=BASE_URL.slice(0,-1)
    
    // alert(`${BASE_URL + path}`)
  return BASE_URL + path;
};

 
export const isSmallScreen = () => {
  return window.innerWidth <= 768;
};

export const handleNumInputChange = (event) => {
  const numericValue = event.target.value.replace(/\D/g, ""); // Remove non-numeric characters
  event.target.value = numericValue; // Update the input value
};
export const handleDecimalInputChange = (event) => {
  const numericValue = event.target.value.replace(/[^0-9.]+/g, "");
  const parts = numericValue.split(".");
  if (parts.length > 2) {
    const integerPart = parts.shift();
    const decimalPart = parts.join("");
    event.target.value = `${integerPart}.${decimalPart}`;
  } else {
    event.target.value = numericValue;
  }
};
export const handleAlphanumericInputChange = (event) => {
  const alphanumericValue = event.target.value.replace(/[^a-zA-Z0-9]+/g, ""); // Remove non-alphanumeric characters
  event.target.value = alphanumericValue; // Update the input value
};

export const handleAlphanumericInputwithSpaceChange = (event) => {
  const alphanumericValue = event.target.value.replace(/[^a-zA-Z0-9\s]+/g, ""); // Remove non-alphanumeric characters except spaces
  event.target.value = alphanumericValue; // Update the input value
};

export const getHourTime = (dateTime, ishour) => {
  let bal = false;
  if (ishour.toString() === "12".toString()) {
    bal = true;
  } else {
    bal = false;
  }
  let curDate = new Date(dateTime);
  const timeString = curDate.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: bal,
  });
  return timeString;
};

export const formatUTCDate = (date, isFormat, daysAgo = 0) => {
  const monthNames = [
    "Jan","Feb","Mar","Apr",
    "May","Jun","Jul","Aug",
    "Sep","Oct","Nov","Dec",
  ];
  if (daysAgo !== 0) {
    date.setUTCDate(date.getUTCDate() - daysAgo);
  }
  date = new Date(date + "Z");
  let year = date.getUTCFullYear();
  let month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are zero-based
  let day = String(date.getUTCDate()).padStart(2, "0");
  let hours = String(date.getUTCHours()).padStart(2, "0");
  let minutes = String(date.getUTCMinutes()).padStart(2, "0");
  let seconds = String(date.getUTCSeconds()).padStart(2, "0");
  if (isFormat === "ymd") {
    return `${year}-${month}-${day}`;
  } else if (isFormat === "dmy") {
    return `${day}-${month}-${year}`;
  } else if (isFormat === "d3my") {
    const monthIndex = date.getUTCMonth();
    month = monthNames[monthIndex];
    return `${day}-${month}-${year}`;
  } else if (isFormat === "ymdhm") {
    return `${year}-${month}-${day} ${hours}:${minutes}`;
  } else if (isFormat === "dmyhm") {
    let period = "AM";
    if (hours >= 12) {
      period = "PM";
      hours = hours > 12 ? hours - 12 : hours;
    } else if (hours === 0) {
      hours = 12;
    }
    hours = String(hours).padStart(2, "0");
    return `${day}-${month}-${year} ${hours}:${minutes} ${period}`;
  }
};

export const handleMaxLengthInput = (event, maxLength) => {
  if (event.target.value.length > maxLength) {
    event.target.value = event.target.value.slice(0, maxLength);
  }
};

export const handleFocus = (event) => {
  event.target.select();
};

export const handleUserSetLocalStorage = (data,key,isRemove = false) => {
  if (isRemove) {    
      localStorage.removeItem(key);
   } else {    
      localStorage.setItem(key, JSON.stringify(data));
   }
};

export const handleCheckUserLogin = (key,getKey) => {
  let storedData = localStorage.getItem(key);

  // Ensure storedData is valid before parsing
  if (!storedData) {
    return 0; // Return default value if no data exists
  }

  try {
    const parsedData = JSON.parse(storedData);
    return parsedData && parsedData[getKey] ? parsedData[getKey] : 0;
  } catch (error) {
    // console.error("Error parsing JSON from localStorage:", error);
    return 0; // Return default value if parsing fails
  }
};

export const handleUserGetLocalStorage = (key) => {
  let storedData = {};
  storedData = localStorage.getItem("udata");
  const parsedData = storedData ? JSON.parse(storedData) : 0;
  return parsedData ? parsedData[key] : 0;
};

export const setCookie = (name, value, minutesToExpire) => {
  const date = new Date();
  date.setTime(date.getTime() + (minutesToExpire * 60 * 1000)); // Set expiry date in minutes
  const expires = "expires=" + date.toUTCString();
  document.cookie = `${name}=${value}; ${expires}; path=/`; // Set cookie
};

export const deleteCookie = (name) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
};

export const getCookie = (cookieName) => {
  const cookies = document.cookie.split("; ");
  for (let cookie of cookies) {
    const [name, value] = cookie.split("=");
    if (name === cookieName) return value;
  }
  return null;  // Return null if cookie is not found
};

// Function to check if the token is expired or not
export const isTokenExpired = (token) => {
  const cookies = document.cookie;  
  
  if (!token) return true; // If no token, it's expired
  
  const tokenParts = token.split(".");
  
  if (tokenParts.length !== 3) return true; // Invalid JWT format

  try {
    const payload = JSON.parse(atob(tokenParts[1])); // Decode payload (base64)
    const expiryTime = payload.exp; // Get `exp` (expiration time in seconds)
    
    if (!expiryTime) return true; // If no `exp`, consider it expired

    const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
    return currentTime >= expiryTime; // Check expiration
  } catch (error) {
    
    console.error("Failed to decode token:", error);
    return true; // Invalid token, treat as expired
  }
};

export const formatUTCDate_dmy = (dateInput) => {
  const date = new Date(dateInput);
  const day = String(date.getUTCDate()).padStart(2, '0');
  const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const year = date.getUTCFullYear();
  return `${day}-${month}-${year}`;
};

export const formatDateToShortUTC=(dateInput)=> {
  const date = new Date(dateInput);
  if (isNaN(date)) return "";

  const day = String(date.getUTCDate()).padStart(2, "0");
  const monthShort = date.toLocaleString("en-US", {
    month: "short",
    timeZone: "UTC",
  });
  const year = String(date.getUTCFullYear()).slice(-2);

  return `${day} ${monthShort} ${year}`;
}

export const smartSearch = ({
  data = [],
  searchText = "",
  field = "search_field",
  mode = "AND", // AND | OR
}) => {
  if (!searchText?.trim()) return data;

  const keywords = searchText
    .toLowerCase()
    .split(" ")
    .filter((k) => k.trim() !== "");

  return data.filter((item) => {
    const value = (item?.[field] || "").toLowerCase();

    if (mode === "AND") {
      return keywords.every((word) => value.includes(word));
    }

    // OR mode
    return keywords.some((word) => value.includes(word));
  });
};

export const handleImageLoad = (event,setAspectRatio) => {
  const { naturalWidth, naturalHeight } = event.target;
  setAspectRatio(`${naturalWidth} / ${naturalHeight}`);    
};